// Science of Reading progression. Levels render in ARRAY ORDER; unlock is sequential.
export const AVATARS = {
  lion: { emoji: "🦁", label: "Leo the Lion" },
  monkey: { emoji: "🐵", label: "Mia the Monkey" },
  star: { emoji: "⭐", label: "Sam the Star" },
  fox: { emoji: "🦊", label: "Finn the Fox" },
  owl: { emoji: "🦉", label: "Ollie the Owl" },
  frog: { emoji: "🐸", label: "Pip the Frog" },
  unicorn: { emoji: "🦄", label: "Uni the Unicorn" },
  dino: { emoji: "🦕", label: "Dot the Dino" },
};

export const LEVELS = [
  {
    id: 1,
    title: "Sound Safari",
    phase: "Phonemic Awareness",
    game: "feeding",
    color: "#8B5CF6",
    icon: "🍔",
    desc: "Feed the monster the food that starts with the right sound!",
    rounds: [
      { sound: "m", options: [ { label: "Milk", emoji: "🥛", letter: "m" }, { label: "Sock", emoji: "🧦", letter: "s" }, { label: "Ball", emoji: "⚽", letter: "b" } ] },
      { sound: "s", options: [ { label: "Sun", emoji: "☀️", letter: "s" }, { label: "Cake", emoji: "🍰", letter: "c" }, { label: "Frog", emoji: "🐸", letter: "f" } ] },
      { sound: "f", options: [ { label: "Fish", emoji: "🐟", letter: "f" }, { label: "Moon", emoji: "🌙", letter: "m" }, { label: "Ring", emoji: "💍", letter: "r" } ] },
      { sound: "r", options: [ { label: "Rocket", emoji: "🚀", letter: "r" }, { label: "Sock", emoji: "🧦", letter: "s" }, { label: "Milk", emoji: "🥛", letter: "m" } ] },
    ],
  },
  {
    id: 2,
    title: "Letter Lagoon",
    phase: "Letter-Sound",
    game: "feeding",
    showLetters: true,
    color: "#22C55E",
    icon: "🔤",
    desc: "Match the letter to its sound and feed the monster!",
    rounds: [
      { sound: "t", options: [ { label: "Tiger", emoji: "🐯", letter: "t" }, { label: "Apple", emoji: "🍎", letter: "a" }, { label: "Pig", emoji: "🐷", letter: "p" } ] },
      { sound: "p", options: [ { label: "Pizza", emoji: "🍕", letter: "p" }, { label: "Banana", emoji: "🍌", letter: "b" }, { label: "Tent", emoji: "⛺", letter: "t" } ] },
      { sound: "b", options: [ { label: "Bus", emoji: "🚌", letter: "b" }, { label: "Dog", emoji: "🐶", letter: "d" }, { label: "Gift", emoji: "🎁", letter: "g" } ] },
      { sound: "d", options: [ { label: "Duck", emoji: "🦆", letter: "d" }, { label: "Pear", emoji: "🍐", letter: "p" }, { label: "Top", emoji: "🔝", letter: "t" } ] },
    ],
  },
  {
    id: 3,
    title: "Bridge of Blends",
    phase: "CVC Blending",
    game: "bridge",
    color: "#F59E0B",
    icon: "🌉",
    desc: "Build the bridge by tapping the letters in order to make a word!",
    words: ["cat", "pig", "sun", "dog", "hat"],
  },
  {
    id: 7,
    title: "Blend Blastoff",
    phase: "Digraphs & Blends",
    game: "digraph",
    color: "#14B8A6",
    icon: "🚀",
    desc: "Pick the two letters that make one sound to finish the word!",
    rounds: [
      { target: "sh", word: "ship", emoji: "🚢", before: "", after: "ip", options: ["sh", "ch", "th"] },
      { target: "ch", word: "chair", emoji: "🪑", before: "", after: "air", options: ["ch", "sh", "st"] },
      { target: "th", word: "thumb", emoji: "👍", before: "", after: "umb", options: ["th", "sh", "bl"] },
      { target: "st", word: "star", emoji: "⭐", before: "", after: "ar", options: ["st", "sh", "ch"] },
      { target: "bl", word: "block", emoji: "🧱", before: "", after: "ock", options: ["bl", "st", "th"] },
    ],
  },
  {
    id: 4,
    title: "Bubble Bay",
    phase: "Sight Words",
    game: "bubble",
    color: "#38BDF8",
    icon: "🫧",
    desc: "Listen, then pop the bubble with the matching word!",
    words: ["the", "said", "was", "see", "like", "you", "are", "have"],
  },
  {
    id: 5,
    title: "Magic Meadow",
    phase: "Magic E (Silent E)",
    game: "magic",
    color: "#EC4899",
    icon: "🪄",
    desc: "Wave the magic wand to add a silent E and change the word!",
    pairs: [
      { short: "hop", long: "hope" },
      { short: "can", long: "cane" },
      { short: "pin", long: "pine" },
      { short: "tub", long: "tube" },
      { short: "cap", long: "cape" },
    ],
  },
  {
    id: 6,
    title: "Story Summit",
    phase: "Decodable Storybooks",
    game: "reader",
    color: "#FF6B6B",
    icon: "📖",
    desc: "Read a story using all the sounds you have learned!",
    stories: [
      {
        title: "The Big Cat",
        pages: ["The cat sat on a mat.", "The cat had a hat.", "The cat ran to the sun.", "The big cat is my pal!"],
      },
      {
        title: "Pip the Pig",
        pages: ["Pip is a pig.", "Pip can dig in the mud.", "Pip had a big hug.", "I like Pip the pig!"],
      },
    ],
  },
];

export function getLevel(id) {
  return LEVELS.find((l) => l.id === Number(id));
}

// Sequential unlock based on array order.
export function isLevelUnlocked(levelId, progress = {}) {
  const idx = LEVELS.findIndex((l) => l.id === Number(levelId));
  if (idx <= 0) return true;
  const prev = LEVELS[idx - 1];
  return !!progress[String(prev.id)]?.completed;
}

export function nextLevelId(levelId) {
  const idx = LEVELS.findIndex((l) => l.id === Number(levelId));
  if (idx === -1 || idx + 1 >= LEVELS.length) return null;
  return LEVELS[idx + 1].id;
}
